import { Injectable } from '@angular/core';
import { Query } from 'apollo-angular';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Utilities } from '@challenger/care/services/utilities/utilities';

import { FOOTER_QUERY } from 'libs/care/src/lib/services/queries';

@Injectable({
  providedIn: 'root',
})
export class FooterGQL extends Query {
  document = FOOTER_QUERY;
}

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  constructor(private footerGQL: FooterGQL) {}

  getLinks(): Observable<any> {
    return this.footerGQL.fetch().pipe(map((result: any) => Utilities.clone(result)));
  }
}
